// --- 语义资产枚举(SA-01 / SA-02 / SA-05 / SA-06) ---

/**
 * 术语→稳定概念迁移状态(SA-01)
 *
 * 旧 GlossaryTerm 升级为稳定 Concept 体系的过程状态。空=未迁移,旧术语继续按 term 工作。
 */
export enum ConceptMigrationStatusEnum {
  /** 待迁移(旧术语,未分配 conceptId) */
  Pending = "pending",
  /** 已迁移(已分配稳定 conceptId) */
  Migrated = "migrated",
  /** 迁移失败(需人工处理) */
  Failed = "failed",
}

/**
 * 命名空间作用域(SA-02)—— 三级链:系统标准 → 团队标准 → 知识库局部扩展
 */
export enum NamespaceScopeTypeEnum {
  /** 系统标准(内置,不可直接修改,可复制派生) */
  System = "system",
  /** 团队标准(租户内复用) */
  Team = "team",
  /** 知识库局部(仅特定 KB 生效) */
  Kb = "kb",
}

/** 列表筛选字面量(词表/度量/数据模型列表共用):表示「仅全局命名空间(namespaceId 为空)」 */
export const NAMESPACE_FILTER_GLOBAL = "global";

/**
 * 度量代码(SA-06 首批预置)
 *
 * 语义资产组定义度量与单位换算规则,数据抽取组执行换算,原始值与原始单位始终保留。
 * 首批换算仅支持:线性(y=a*x+b)、线性加偏移、等值符号转换;非线性(如硬度 HV/HRC/GPa)显式禁止。
 */
export enum QuantityKindCodeEnum {
  Temperature = "temperature",
  Length = "length",
  Pressure = "pressure",
  Time = "time",
  Mass = "mass",
  Density = "density",
  Strength = "strength",
  ElasticModulus = "elasticModulus",
  Frequency = "frequency",
  MagneticFieldStrength = "magneticFieldStrength",
  Magnetization = "magnetization",
  EnergyPerMole = "energyPerMole",
  Percentage = "percentage",
  Dimensionless = "dimensionless",
}

/** 词表项状态(SA-05) */
export enum VocabularyItemStatusEnum {
  Active = "active",
  Deprecated = "deprecated",
}

/**
 * 概念标签类型(评审修正 D7)—— SemanticConcept 的非首选名称分类
 *
 * 用于 ConceptResolver 的前 4 级匹配优先级区分。
 */
export enum ConceptLabelTypeEnum {
  /** 缩写/公式符号(如 Tg、Dmax) */
  Abbreviation = "abbreviation",
  /** 同义词(不同表述,同一概念) */
  Synonym = "synonym",
  /** 符号(化学式等) */
  Symbol = "symbol",
}
